import React from 'react'

const IconShapeEllipse = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <ellipse cx='12' cy='12' rx='8' ry='6' />
      </svg>
   )
}
export default IconShapeEllipse
